import { useState } from "react";
import { DevicesTableModel } from "../models/tables.model";

export const useMapData = () => {

    const [ tableRow, setTableRow ] = useState({});

    const onTableDevicesClick = (row) => {
        setTableRow(row)
    }

    return {
        onTableDevicesClick,
        tableRow,
        tableRowId: (tableRow && tableRow[DevicesTableModel.DeviceID]) || -1
    };
};
